/* eslint-disable prefer-template, react/jsx-no-bind */
import classnames from 'classnames';
import React from 'react';
import { t } from 'es6/services/localization';
import { QuizDirection } from 'es6/models/user-settings';

/**
 * Mixin for the other panels.
 */
export const PanelMixin = {
  /**
   * onDataChange is used to update the state of the setting window
   */
  propTypes: {
    inSession: React.PropTypes.bool.isRequired,
    onDataChange: React.PropTypes.func.isRequired,
    userSettings: React.PropTypes.object.isRequired,
  },

  /**
   * Panels using this mixin should define a tab name.
   *
   * statics: {
   *    getTabName: function() {
   *      return 'Tabname goes here';
   *    };
   * }
   */

  _handleTypingSpecialCharactersChange(typingSpecialCharacters) {
    const attrs = {
      apps: {
        typingSpecialCharacters,
      },
    };

    this.props.onDataChange.call(this, attrs);
  },

  /**
   * Helper method to render a On/Off setting. Will bind the boolean value
   * to the onChange method.
   *
   * @param {String} key            key to distinguish radio button groups
   * @param {Boolean} value         whether toggle is on or off
   * @param {Boolean} isDisabled    disables the toggle
   * @param {Function} onChange     callback method when toggle is changed
   */
  _renderToggle(key, value, isDisabled = false, onChange) {
    const onId = key + '-on';
    const offId = key + '-off';

    return (
      <div className="input radio-input">
        <input className="primary" id={onId} name={key} disabled={isDisabled} type="radio" value checked={value} onChange={onChange.bind(null, true)} />
        <label htmlFor={onId}>{t('on')}</label>
        <input className="secondary" id={offId} name={key} disabled={isDisabled} type="radio" value={false} checked={!value} onChange={onChange.bind(null, false)} />
        <label htmlFor={offId}>{t('off')}</label>
      </div>
    );
  },

  /**
   * Helper for rendering typing special characters, as it is used in
   * several settings windows.
   */
  _renderTypingSpecialCharactersToggle() {
    const typingSpecialCharacters = this.props.userSettings.apps.typingSpecialCharacters;

    return (
      <div className="setting">
        <h4>{t('type special characters')}</h4>
        {this._renderToggle('typingSpecialCharacters', typingSpecialCharacters, false, this._handleTypingSpecialCharactersChange)}
      </div>
    );
  },

  /**
   * Helper method for rendering quiz direction options.
   *
   * @param {String} value          the current value
   * @param {Function} onChange     callback for when toggle is changed
   */
  _renderQuizDirectionOptions(value, onChange) {
    // These settings must be disabled while in session.
    const className = classnames('content-columns', { disabled: this.props.inSession });

    return (
      <div className="quiz-settings quiz-settings-quick-review">
        <div className={className}>
          {this._renderQuizDirectionColumn(
            QuizDirection.All,
            t('js_iknow.both'),
            t('quiz-direction-description-both'),
            value === QuizDirection.All, onChange
          )}
          {this._renderQuizDirectionColumn(
            QuizDirection.Forward,
            t('forward'),
            t('quiz-direction-description-forward'),
            value === QuizDirection.Forward, onChange
          )}
          {this._renderQuizDirectionColumn(
            QuizDirection.Reverse,
            t('reverse'),
            t('quiz-direction-description-reverse'),
            value === QuizDirection.Reverse, onChange
          )}
        </div>
      </div>
    );
  },

  /**
   * Renders a column.
   *
   * @param {Number} value    the actual value of the radio box.
   * @param {String} title
   * @param {String} description
   * @param {Function} onChange
   */
  _renderQuizDirectionColumn(value, title, description, isChecked = false, onChange) {
    const id = `quiz-direction-${name}`;

    return (
      <p className="content-column">
        <input type="radio" id={id} disabled={this.props.inSession} name="quiz-direction" checked={isChecked} value={value} onChange={onChange.bind(null, value)} />
        <label htmlFor={id}>
          <span className="title">{title}</span>
          <span className="description">{description}</span>
        </label>
      </p>
    );
  },
};

export default PanelMixin;
